<template>
  <div>
    <utility-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter" :paginationData="filterSet.page" :utilTopCategory="utilityTopCategoryList" :utilBottomCategory="utilityBottomCategoryList"></utility-filter-link>
    <utility-list-link ref="utilityListLink" :listLayout="listLayout" :utilityData="List" :utilTopCategory="utilityTopCategoryList" :utilBottomCategory="utilityBottomCategoryList" :paginationData="filterSet.page"></utility-list-link>
    <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
  </div>
</template>

<script>
import PaginationLink from "@/components/utility/PaginationLink.vue";
import utilityUtil from "@/components/utility/utilityUtil";
import UtilityListLink from "@/components/utility/UtilityListLink.vue";
import UtilityFilterLink from "@/components/utility/UtilityFilterLink.vue";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";

const {filterConfig} = utilityUtil;

export default {
  name: "UtilityPubListComponent",
  mixins: [utilityUtil, filterMixins, listMixins, alertMixins],
  components: {PaginationLink, UtilityListLink, UtilityFilterLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
      utilityListSetData: this.setData,
    }
  },
  props: {
    utilityType: {
      default: () => {
      }
    },
    utilKey: {default: 0},
  },
  data() {
    return {
      filterLayout: '',
      listLayout: '',
      paginationLayout: '',
      getFunc: '',
      listApiParamSet: {},
      pageRow: 10,
      paginationType:'',

      utilityTopCategoryList: [],
      utilityBottomCategoryList: [],

      keyName: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig)
    this.setParserType('url', this.$route.fullPath);
  },
  mounted() {
    this.getList(true);
    this.getUtilTopCategory();
    this.getUtilBottomCategory();
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    setData(type, value) {
      this[type] = value;
    },
    initConfig() {
      let config = this.returnUtilityConfig(this.utilityType);
      this.listLayout= config.listLayout;
      this.filterLayout = config.filterLayout;
      this.paginationLayout = config.paginationLayout;
      this.getFunc = config.getFunc;
      this.listApiParamSet = config.listApiParamSet;
      this.paginationType =config.paginationType;
      this.keyName = config.keyName;

      if (config.pageRow && config.pageRow != this.filterSet.page.size) {
        this.pageRow = config.pageRow;
        this.filterSet.page.size = config.pageRow;
        this.pageClass.setterPage('size', this.pageRow);
      }

      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      if (!util.isEmpty(this.utilKey)) {
        params[this.keyName] = this.utilKey
      }

      let listOptions = {
        url : this.$api.$utility[this.getFunc],
        defaultParams : params
      }
      this.initList('api', listOptions);
    },
    getUtilTopCategory() {
      let params = {
        parent : [0],
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityTopCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getUtilBottomCategory() {
      let params = {
        child : 1,
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityBottomCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
